import type { Service } from '../types/service'

export const services: Service[] = [
  {
    id: '1',
    title: 'Þjónusta Við Sjávarútveg',
    shortDescription: 'Viðhald, viðgerðir og sérsmíðaðar lausnir fyrir sjávarútveginn.',
    description:
      'Við bjóðum upp á áreiðanlega þjónustu fyrir sjávarútveginn, þar með talið viðhald, viðgerðir og sérsmiðaðar lausnir sem tryggja öruggan og skilvirkan rekstur.',
    icon: 'directions_boat',
    image: '/marine-service.png'
  },
  {
    id: '2',
    title: 'Stálsmíði',
    shortDescription: 'Sérsmíði og lausnir úr stáli fyrir fjölbreytt verkefni.',
    description:
      'Sérsmíði og lausnir úr stáli fyrir fjölbreytt verkefni. Við tryggjum gæði, nákvæmni og endingu sem stenst krefjandi aðstæður.',
    icon: 'construction',
    image: '/steel-work.png'
  },
  {
    id: '3',
    title: 'Rennismíði',
    shortDescription: 'Fagleg rennismíði fyrir nákvæmni og áreiðanleika.',
    description:
      'Fagleg rennismíði fyrir nákvæmni og áreiðanleika í smærri og stærri verkefnum. Við veitum lausnir sem henta þínum þörfum.',
    icon: 'precision_manufacturing',
    image: '/machining.png'
  },
  {
    id: '4',
    title: 'Þjónusta Við Smábáta',
    shortDescription: 'Viðhalds- og viðgerðarþjónusta fyrir smábáta.',
    description:
      'Viðhalds- og viðgerðarþjónusta fyrir smábáta, frá reglulegu eftirliti til neyðarviðgerða. Tryggjum að báturinn þinn sé sjófær og öruggur.',
    icon: 'water',
    image: '/small-boats.png'
  }
]
